import React from 'react';
import PropTypes from 'prop-types';

const FacebookShare = ({ color = '#337FFF', ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={17} height={31} fill="none" {...props}>
    <path
      fill={color}
      d="m15.14 17.39.855-5.427h-5.266V8.436c0-1.484.735-2.934 3.086-2.934h2.428V.881a29.452 29.452 0 0 0-4.275-.365c-4.334 0-7.164 2.603-7.164 7.31v4.137H0v5.427h4.804v13.126h5.925V17.39h4.41Z"
    />
  </svg>
);

FacebookShare.propTypes = {
  color: PropTypes.string
};

export default FacebookShare;
